import React from 'react';
import PropTypes from 'prop-types';
import { FaFileExcel } from 'react-icons/fa';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import { SpinnerIcon } from '@/shared/components/Icons';
import intlShape from '@/shared/utils/intlShape';
import messages from '../reportingMessages';

const ExportToExcelDropdown = ({ exporting, createExcel, intl }) => (
  <DropdownButton
    bsSize="xsmall"
    bsStyle="default"
    className="btn-default"
    id="excel-export-button"
    disabled={exporting}
    pullRight
    title={
      <span>
        {exporting ? <SpinnerIcon /> : <FaFileExcel className="file-icon" />}
        <span>{intl.formatMessage(messages.ExportToExcel)}</span>
      </span>
    }
  >
    <MenuItem onSelect={() => createExcel(false)} id="excel-export-button-bla">
      <span className="margin5R">
        <FaFileExcel className="file-icon excel" />
      </span>
      {intl.formatMessage(messages.ExportToExcel)}
    </MenuItem>
    <MenuItem onSelect={() => createExcel(true)} id="excel-export-button-bla">
      <span className="margin5R">
        <FaFileExcel className="file-icon excel" />
      </span>
      {intl.formatMessage(messages.ExportDetailsToExcel)}
    </MenuItem>
  </DropdownButton>
);
ExportToExcelDropdown.propTypes = {
  intl: intlShape.isRequired,
  createExcel: PropTypes.func.isRequired,
  exporting: PropTypes.bool,
};
ExportToExcelDropdown.defaultProps = {
  exporting: false,
};

export default ExportToExcelDropdown;
